import DeliveryGuaranteeTNCPanel from './delivery-guarantee-tnc-panel';

export default DeliveryGuaranteeTNCPanel;
